
const mutations={
  updateTest(state,value){state.technician.test=value},//test测试
  updateSynchronizeTime(state,value){state.technician.synchronize_time=value},//更新数据同步时间
  updateUserStatus(state,value){state.userStatus=value},//更新用户状态
  updateRenderBarList(state,value){state.technician.renderBarList=value},//修改tabbar菜单
  updateCursNodeId1(state,value){state.userStatus.curs_node_id_1=value},//缓存门店id
  updateTechnicianPower(state,value){state.userStatus.technician_power=value},//缓存菜单权限
  updateRadioMember(state,value){state.technician.radioMember=value},//更新选择的会员信息
  updateBlessing(state,value){state.technician.blessing=value},//更新祝福语
  updateNotify_money(state,value){state.userStatus.notify_money=value},
  updateNotify_space_day(state,value){state.userStatus.notify_space_day=value}
}
export default mutations
